import React, { Component } from 'react'
import { ReactTypeformEmbed } from 'react-typeform-embed'
import PropTypes from 'prop-types'
import AriaModal from 'react-aria-modal'
import { Icon } from 'loyal-react'

class Nps extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false
    }
    setTimeout(() => {
      this.setState({ showModal: this.props.closeDonation })
    }, 1000)
  }
  getApplicationNode = () => {
    return document.querySelector('#root')
  }
  closeNPS () {
    this.setState({ showModal: false })
  }
  render () {
    return process.env.REACT_APP_NPS ? (
      this.state.showModal &&
      <AriaModal
        titleText='Como foi sua experiência?'
        onExit={() => this.closeNPS()}
        focusDialog='true'
        getApplicationNode={this.getApplicationNode}
        underlayStyle={{ paddingTop: '100px', zIndex: 9999 }}
      >
        <div data-campaign={process.env.REACT_APP_CATALOG_ID}>
          <div className='pos-absolute zindex-high r-3 t-3'>
            <a role='button'
              href='javascript:void(0)'
              aria-label='Fechar'
              onClick={() => this.closeNPS()} className='txt-subtitle txt-font-body color-ui-2 d-block'>
              <Icon
                iconName='icon_close'
                className='color-ui-3 cursor'
              />
            </a>
          </div>
          <ReactTypeformEmbed url={this.props.urlNps || process.env.REACT_APP_NPS} />
        </div>
      </AriaModal>
    )
      : ''
  }
}

Nps.propTypes = {
  closeDonation: PropTypes.bool,
  urlNps: PropTypes.string
}

export default Nps



// WEBPACK FOOTER //
// ./src/features/Nps/index.js